import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import { useModal } from 'components/ModalProvider/hooks';
import { logEvent } from 'features/Analytics/analytics';

import { useClientModalContext } from '../../../../components/Modals';
import { ClientModalType } from '../../../../components/Modals/types';
import locales from './locales';

const ListHeader: FC = () => {
  const { showModal } = useModal();
  const { setClient } = useClientModalContext();

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      marginBottom="space-32"
    >
      <Heading size="lg">{locales.title}</Heading>

      <Button
        icon="plus"
        iconPosition="left"
        onClick={() => {
          logEvent({
            name: 'Add Client',
            properties: {
              from: 'ClientListPage',
            },
          });
          setClient(null);
          showModal(ClientModalType.CreateEdit);
        }}
        variant="secondary"
      >
        {locales.add}
      </Button>
    </Flex>
  );
};

export default ListHeader;
